import { ConfigProvider } from 'antd'

const ANTDConfigProvider = ({ ...props }) => {
  return <ConfigProvider {...props} />
}

export default ANTDConfigProvider
